// extracted by mini-css-extract-plugin
export default {"suggestie":"styles_suggestie__ikBTD","suggestie__tekst":"styles_suggestie__tekst__VYZn4","suggestie__chip":"styles_suggestie__chip__FpaZV"};